module.exports = __webpack_public_path__ + "img/hanser.98ae9831.jpg";